export type SupabasePublicEnv = {
  url: string
  anonKey: string
}

export function getSupabasePublicEnv(): SupabasePublicEnv {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL
  const anonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

  const missing: string[] = []
  if (!url) {
    missing.push('NEXT_PUBLIC_SUPABASE_URL')
  }
  if (!anonKey) {
    missing.push('NEXT_PUBLIC_SUPABASE_ANON_KEY')
  }

  if (!url || !anonKey) {
    throw new Error(
      `Missing required Supabase env var(s): ${missing.join(', ')}`,
    )
  }

  return { url, anonKey }
}
